// cfgmenus

const state = {
	cfgmenus: {},
	
};

export default state;